import { AppRouteProps } from "@harea/component";
import React from "react";

const NotificationContainer = React.lazy(() => import("container/NotificationContainer"));
export const NotificationRoutes = [
    {
        path: "notifications",
        element: <NotificationContainer />,
        title: "BSMRH.Notification.Title",
    },
] as Array<AppRouteProps>;
